import { Component, ViewEncapsulation } from '@angular/core';
import { declarationOfInterestReply } from 'src/interface/shared.interface';
import { response } from 'src/interface/shared.interface';
import { HelperFunctionsService } from 'src/services/helperFunctions/helper-functions.service';
import { ContextService } from 'src/services/platform/context.service';
import { PlatformService } from 'src/services/platform/platform-service.service';

@Component({
  selector: 'app-reply-message-content',
  templateUrl: './reply-message-content.component.html',
  styleUrls: ['./reply-message-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReplyMessageContentComponent {
  reply: declarationOfInterestReply;
  loading = true;
  response: response = {
    GoodMatchAndAvailable: 'Yes, it’s a good match & I’m available',
    GoodMatchButNotAvailable: 'Yes, it’s a good match but I’m not available',
    NotGoodMatchAndAvailable: 'I am available, but it’s not a good match',
    NotGoodMatchAndNotAvailable: 'I am not available & it’s not a good match',
  };
  constructor(
    private contextService: ContextService,

    private helperFunction: HelperFunctionsService
  ) {}
  ngOnInit() {
    this.contextService.reRender.subscribe((val) => {
      if (val === 'replyMessage') {
        this.reply = this.contextService.declarationOfInterestReply;
        this.loading = false;
      }
    });
  }
  match(value: string) {
    const key = value as keyof response;
    return this.response[key];
  }
  getDate(date: number | string, iso?: string) {
    if (iso) {
      date = Math.floor(new Date(date).getTime() / 1000);
    }
    return this.helperFunction.getDate(date as number, iso ? false : true);
  }
}
